import { Image, Link } from "@customTypes/index";
import { Col, Row } from "antd";

interface TopTenSplitCtaProps {
  className?: string;
  flip?: boolean;
  title?: string;
  date?: string;
  description?: string;
  link: Link;
  image: Image;
}

const defaultProps: TopTenSplitCtaProps = {
  className: "",
  flip: false,
  title: "No title found",
  date: "March 24, 2021",
  description: "quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
  link: {
    url: "/",
    name: "Click Me!",
    target: "_self",
  },
  image: {
    src: "https://covrprice.com/wp-content/uploads/2020/02/STL145248.jpg",
    alt: "no image",
  },
};

const TopTenSplitCta = ({ className, title, date, description, link, flip, image }: TopTenSplitCtaProps) => {
  let direction: any = flip ? "row-reverse" : "";

  return (
    <a target={link.target} href={link.url}>
      <Row
        className={`covr-cta-split ${className}`}
        style={{
          flexDirection: direction,
        }}
      >
        <Col span={12} className="image">
          <img src={image.src} alt={image.alt} loading="lazy" />
        </Col>
        <Col span={12} className="details">
          <h4>{date}</h4>
          <h3>{title}</h3>
          <p>{description}</p>
        </Col>
      </Row>
    </a>
  );
};

TopTenSplitCta.defaultProps = defaultProps;

export default TopTenSplitCta;
